// Locale message bundles (see ./en.json, ./de.json).
import en from './en';
import de from './de';

export default {
  en,
  de,
};
